export const TOPICS = {
  aero: {
    label: 'Aerodynamics & Flight Principles',
    icon: '✈️',
    color: 'var(--accent)',
    subtopics: [
      'Four Forces of Flight — Lift, Drag, Thrust & Weight',
      'How Wings Generate Lift — Bernoulli & Newton',
      'Stalls and Spins — Causes, Recognition & Recovery',
      'Stability and Control — Axes of Flight',
      'Propeller Aerodynamics and P-Factor',
      'Ground Effect and Takeoff Performance',
    ],
  },
  weather: {
    label: 'Weather & Meteorology',
    icon: '🌤️',
    color: 'var(--amber)',
    subtopics: [
      'The Atmosphere — Layers, Pressure & Temperature',
      'Wind Patterns — Surface, Gradient & Jet Stream',
      'Clouds and Precipitation — Formation and Types',
      'METARs and TAFs — Decoding Aviation Weather Reports',
      'AIRMETs, SIGMETs and Pilot Weather Reports',
      'Thunderstorms and Icing — Hazards and Avoidance',
    ],
  },
  nav: {
    label: 'Navigation & Charts',
    icon: '🗺️',
    color: 'var(--green)',
    subtopics: [
      'Sectional Aeronautical Charts — How to Read Them',
      'Pilotage and Dead Reckoning',
      'VOR Navigation — Using VHF Omnidirectional Range',
      'GPS and RNAV for VFR Pilots',
      'E6B Flight Computer — Time, Speed, Distance',
      'Lost Procedures and Diversion Techniques',
    ],
  },
  regs: {
    label: 'FAA Regulations',
    icon: '📋',
    color: 'var(--red)',
    subtopics: [
      'Airspace Classifications — Class A through G',
      'Visual Flight Rules (VFR) Minimums by Airspace',
      'Pilot Certificates and Medical Requirements',
      'Flight Planning and Fuel Requirements (FAR 91)',
      'Right of Way Rules and Traffic Patterns',
      'Airworthiness — Annual Inspections and MELs',
    ],
  },
  radio: {
    label: 'Radio Communications',
    icon: '📡',
    color: 'var(--purple)',
    subtopics: [
      'Phonetic Alphabet and Standard Phraseology',
      'Talking to ATC — Clearances and Readbacks',
      'Transponder Codes — 1200, 7500, 7600, 7700',
      'CTAF and Uncontrolled Airport Operations',
    ],
  },
  systems: {
    label: 'Aircraft Systems',
    icon: '⚙️',
    color: 'var(--text2)',
    subtopics: [
      'Reciprocating Engines — How a Lycoming Works',
      'Fuel Systems — Tanks, Sumps and Fuel Grades',
      'Electrical Systems — Bus, Battery and Alternator',
      'Pitot-Static System and Flight Instruments',
      'Vacuum System and Gyroscopic Instruments',
    ],
  },
};

export const DASHBOARD_MODULES = [
  { key: 'aero',    icon: '✈️', cls: 'mod-aero', name: 'Aerodynamics & Flight Principles', lessons: 8, hours: '2.4h', pct: 100, status: 'completed' },
  { key: 'weather', icon: '🌤️', cls: 'mod-wx',   name: 'Weather & Meteorology',            lessons: 6, hours: '1.8h', pct: 60,  status: 'active'    },
  { key: 'nav',     icon: '🗺️', cls: 'mod-nav',  name: 'Navigation & Charts',              lessons: 7, hours: '2.1h', pct: 25,  status: 'normal'    },
  { key: 'regs',    icon: '📋', cls: 'mod-regs', name: 'FAA Regulations & Airspace',       lessons: 9, hours: '3.0h', pct: 0,   status: 'locked'    },
  { key: 'radio',   icon: '📡', cls: 'mod-radio',name: 'Radio Communications',             lessons: 4, hours: '1.2h', pct: 0,   status: 'locked'    },
];

export const QUIZ_TOPICS = [
  { topic: 'Aerodynamics and Flight Principles for private pilots — lift, drag, thrust, stalls, spins', label: 'Aerodynamics', icon: '✈️', desc: 'Lift, drag, thrust, weight, stalls' },
  { topic: 'Weather and Meteorology including METARs, TAFs, AIRMETs, SIGMETs, fronts', label: 'Weather', icon: '🌤️', desc: 'METARs, TAFs, AIRMETs, fronts' },
  { topic: 'VFR Navigation — sectional charts, VOR, pilotage, dead reckoning', label: 'Navigation', icon: '🗺️', desc: 'Sectionals, VOR, pilotage' },
  { topic: 'FAA Regulations — FARs, airspace classifications, pilot certificates', label: 'Regulations', icon: '📋', desc: 'FARs, airspace, certificates' },
  { topic: 'Radio communications and ATC phraseology, transponder codes', label: 'Radio Comms', icon: '📡', desc: 'ATC phraseology, transponder' },
  { topic: 'Aircraft systems — engine, fuel, electrical, pitot-static, instruments', label: 'Aircraft Systems', icon: '⚙️', desc: 'Engine, fuel, electrical' },
];
